<template>
    <div  id="claim-profile-modal">
        <div class="page-pretitle text-end">Today is {{ day }}, {{ date }}</div>
        <h2 class="page-title">It's now {{ time }} </h2>        
    </div>
</template>

<script>
    export default {
        name: "TodayDashboard",
        data: function() {
            return {
                timestamp: '',
                time: '',
                date: '',
                day: ''
            }
        },
        created() {
            this.getNow();
            setInterval(this.getNow, 1800000 ); //30 minutes
        },
        methods: {
            getNow: function() {
                const today = new Date();
                this.day = today.toLocaleDateString('en-NZ', { timeZone: 'Etc/GMT-13' , weekday: 'long' })
                this.date = today.toLocaleDateString('en-NZ', { timeZone: 'Etc/GMT-13' });
                this.time = today.toLocaleString('en-NZ', { timeZone: 'Etc/GMT-13' , hour: 'numeric', minute: 'numeric', hour12: true });
            }
        }
    }
</script>
